import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Batteries,BatteriesData} from '../pages/layout/list-batteries/list-batteries.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BatteriesService {

  constructor(private afs: AngularFirestore) { }

  getBatteries(){
    return this.afs.collection<Batteries>(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }
  
  getUnoccupiedBatteries(){
    return this.afs.collection<Batteries>(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesCollection, ref =>
    ref.where('User', '==',"")).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });

  }

  getBatteriesByUser(username){
    return this.afs.collection<Batteries>(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesCollection,ref =>
    ref.where('User', '==',username)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });

  }

  getBatteryByIMEI(imei) {
    return this.afs.collection<Batteries>(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesCollection,ref =>
    ref.where('IMEI', '==',imei)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  getBatteriesData(uid){
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesCollection+'/'+uid).snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as Batteries;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  }

  getBatteriesSummaryData(uid){
    return this.afs.collection('Scooters',ref =>
    ref.where('BatteryID', '==',uid)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as BatteriesData;
        const id = action.payload.doc.id;
        return { id, ...data };
    });
  });;
  } 

  addBatteries(data){
    return new Promise<any>((resolve, reject) => {
      this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesCollection).add(data).then(res => {
        this.editBattery({id: res.id, ...data}, res.id).then(result => {
          resolve(res);
        });
      }, err => reject(err));
    });
  }

  editBattery(data,id){
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesCollection).doc(id).update(data).then(res => {
        resolve(res);
      }, err => reject(err));
  });
  
  }

  deleteBattery(battery) {
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesCollection).doc(battery.id).delete();
}

  addbatteriesType(data) {
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesTypeCollection).add(data).then(res => {
        return new Promise<any>((resolve, reject) => {
          let updatedData = {id:res.id, ...data}
          this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesTypeCollection).doc(res.id).update(updatedData).then(res => {}, err => reject(err));
        });
      }, err => reject(err));
  });
  }

  getBatteriesType() {
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesTypeCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  getBatteryType(uid) {
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesTypeCollection+'/'+uid).snapshotChanges().pipe(map(action => {
      const data = action.payload.data();
      const id = action.payload.id;
      return { id, ...data };
  })
  );
  }

  UpdateBatteryStatus(id,data) {
    this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.BatteriesCollection).doc(id).update({'Status': data});
  }

}
